export default "__VITE_ASSET__BMUd0BPU__"